// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PaginationList_wrapper__1gbHg","title":"PaginationList_title__2EU73"};